(function () {
  const ADD_TO_CART_ICON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="10" cy="20.5" r="1"/><circle cx="18" cy="20.5" r="1"/><path d="M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1"/>
  </svg>`;

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function buildUnitPriceHTML(variant) {
    if (!variant.unit_price) return '';
    const ref = variant.unit_price_measurement;
    const refValue = ref.reference_value === 1 ? '' : ref.reference_value;
    return `<span class="cart-upsell-unit-price">(${formatMoney(variant.unit_price)}/${refValue}${ref.reference_unit})</span>`;
  }

  function buildPriceHTML(variant) {
    const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    return `${hasCompare ? `<s>${formatMoney(variant.compare_at_price)}</s> ` : ''}${formatMoney(variant.price)}`;
  }

  function getImageUrl(image, width) {
    if (!image) return '';
    // Handle both object { url: '...' } and direct string URL formats
    const raw = image.url || image.src || (typeof image === 'string' ? image : '');
    if (!raw) return '';
    // Append width param — handle URLs with existing query params
    return raw + (raw.includes('?') ? '&' : '?') + 'width=' + (width || 200);
  }

  function getImageAlt(image, fallback) {
    if (!image) return fallback;
    return image.alt || fallback;
  }

  // Find the single-pack variant by matching title patterns like "1 x 125g", "1x 90g", "1 × 63g"
  function findSinglePackVariant(product) {
    const singlePackPattern = /^1\s*[x×]\s/i;

    // First: look for a variant whose title starts with "1 x" / "1x" / "1 ×"
    for (const v of product.variants) {
      if (singlePackPattern.test(v.title) && v.available) return v;
    }
    // Second: if only one variant and it's "Default Title", use it
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      return product.variants[0];
    }
    // Third: pick the cheapest available variant as fallback (likely single-pack)
    const available = product.variants.filter(v => v.available);
    if (available.length === 0) return product.variants[0];
    return available.reduce((cheapest, v) => v.price < cheapest.price ? v : cheapest, available[0]);
  }

  const PRICE_THRESHOLD = 1000; // 10€ in cents

  function hasRealVariants(product) {
    if (!product.variants || product.variants.length <= 1) return false;
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') return false;
    return true;
  }

  function buildVariantDropdownHTML(product, selectedVariant) {
    if (!hasRealVariants(product)) return '';
    const options = product.variants.map(v => {
      const selected = v.id === selectedVariant.id ? ' selected' : '';
      const disabled = !v.available ? ' disabled' : '';
      const soldOutLabel = !v.available ? ' (Ausverkauft)' : '';
      return `<option value="${v.id}" data-price="${v.price}" data-compare-price="${v.compare_at_price || ''}" data-unit-price="${v.unit_price || ''}" data-unit-ref-value="${v.unit_price_measurement ? v.unit_price_measurement.reference_value : ''}" data-unit-ref-unit="${v.unit_price_measurement ? v.unit_price_measurement.reference_unit : ''}" data-available="${v.available}"${selected}${disabled}>${v.title}${soldOutLabel}</option>`;
    }).join('');
    return `<select class="cart-upsell__variant-select">${options}</select>`;
  }

  function buildCardHTML(product) {
    const displayVariant = findSinglePackVariant(product);
    const image = displayVariant.featured_image || displayVariant.image || product.featured_image || (product.images && product.images[0]);
    const imgSrc = getImageUrl(image, 200);
    const imgAlt = getImageAlt(image, product.title);

    const isHighPrice = displayVariant.price > PRICE_THRESHOLD;

    // Show variant label only for low-price (qty-button) products
    const variantLabel = !isHighPrice && displayVariant.title !== 'Default Title' ? displayVariant.title : '';

    // Build action area based on price
    let actionHTML = '';
    if (!displayVariant.available && !hasRealVariants(product)) {
      actionHTML = `<p class="cart-upsell__sold-out">Ausverkauft</p>`;
    } else if (isHighPrice) {
      // High-price: variant dropdown + single Add to Cart button
      const variantDropdown = buildVariantDropdownHTML(product, displayVariant);
      const btnDisabled = !displayVariant.available ? ' disabled' : '';
      actionHTML = `
        ${variantDropdown}
        <button type="button" class="cart-upsell__add-btn"${btnDisabled} data-variant-id="${displayVariant.id}">
          ${ADD_TO_CART_ICON}
          <span>In den Warenkorb</span>
        </button>`;
    } else {
      // Low-price: quantity pill buttons (1x, 3x, 6x)
      actionHTML = `
        <div class="cart-upsell__qty-buttons">
          <button type="button" class="cart-upsell__qty-btn" data-variant-id="${displayVariant.id}" data-quantity="1">1x</button>
          <button type="button" class="cart-upsell__qty-btn" data-variant-id="${displayVariant.id}" data-quantity="3">3x</button>
          <button type="button" class="cart-upsell__qty-btn" data-variant-id="${displayVariant.id}" data-quantity="6">6x</button>
        </div>`;
    }

    return `
      <li class="cart-drawer-upsell-list-item">
        <a href="${product.url}" class="cart-drawer-upsell-item-image" tabindex="-1" aria-hidden="true">
          <img src="${imgSrc}" alt="${imgAlt}" width="72" height="72" loading="lazy">
        </a>
        <div class="cart-drawer-upsell-item-content">
          <a href="${product.url}" class="cart-drawer-upsell-item-title">${product.title}</a>
          ${variantLabel ? `<p class="cart-upsell-variant-label">${variantLabel}</p>` : ''}
          <div class="cart-upsell-price-row">
            <span class="cart-upsell-price">${buildPriceHTML(displayVariant)}</span>
            ${buildUnitPriceHTML(displayVariant)}
          </div>
          ${actionHTML}
        </div>
      </li>`;
  }

  async function getCartProductIds() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      const ids = [];
      const seen = new Set();
      for (const item of cart.items) {
        if (!seen.has(item.product_id)) {
          seen.add(item.product_id);
          ids.push(item.product_id);
        }
      }
      return { ids, cartProductIds: seen };
    } catch (e) {
      return { ids: [], cartProductIds: new Set() };
    }
  }

  async function fetchRecommendations(productId, limit) {
    try {
      const resp = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`);
      const data = await resp.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  }

  async function loadRecommendations(container) {
    const list = container.querySelector('.cart-drawer-upsell-list');
    if (!list) return;

    const limit = parseInt(container.dataset.limit || '10', 10);
    const { ids: cartProductIds, cartProductIds: cartIdSet } = await getCartProductIds();

    if (cartProductIds.length === 0) {
      container.hidden = true;
      return;
    }

    // Fetch recommendations for each cart product (up to 3 sources to avoid over-fetching)
    const sources = cartProductIds.slice(0, 3);
    const allFetches = sources.map(id => fetchRecommendations(id, limit));
    const results = await Promise.all(allFetches);

    // Merge & deduplicate: round-robin from each source, skip cart items
    const seen = new Set(cartIdSet);
    const merged = [];
    const maxRounds = limit;

    for (let round = 0; round < maxRounds && merged.length < limit; round++) {
      for (const products of results) {
        if (round < products.length) {
          const p = products[round];
          if (!seen.has(p.id) && p.available) {
            seen.add(p.id);
            merged.push(p);
            if (merged.length >= limit) break;
          }
        }
      }
    }

    if (merged.length === 0) {
      container.hidden = true;
      return;
    }

    // Render cards
    list.innerHTML = merged.map(buildCardHTML).join('');
    container.hidden = false;

    // Bind quantity buttons
    list.querySelectorAll('.cart-upsell__qty-btn[data-variant-id]').forEach(btn => {
      btn.addEventListener('click', handleQtyBtnClick);
    });

    // Bind Add to Cart buttons (high-price products)
    list.querySelectorAll('.cart-upsell__add-btn[data-variant-id]').forEach(btn => {
      btn.addEventListener('click', handleAddBtnClick);
    });

    // Bind variant dropdowns
    list.querySelectorAll('.cart-upsell__variant-select').forEach(select => {
      select.addEventListener('change', handleVariantChange);
    });

    // Init scroll navigation
    initScrollNav(container);
  }

  function handleVariantChange(e) {
    const select = e.currentTarget;
    const selectedOption = select.options[select.selectedIndex];
    const card = select.closest('.cart-drawer-upsell-list-item');
    const addBtn = card.querySelector('.cart-upsell__add-btn');
    if (!addBtn) return;

    const variantId = selectedOption.value;
    const available = selectedOption.dataset.available === 'true';

    addBtn.dataset.variantId = variantId;
    addBtn.disabled = !available;

    // Update price display
    const priceEl = card.querySelector('.cart-upsell-price');
    const unitPriceEl = card.querySelector('.cart-upsell-unit-price');
    if (priceEl) {
      const price = parseInt(selectedOption.dataset.price, 10);
      const comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice, 10) : 0;
      const hasCompare = comparePrice && comparePrice > price;
      priceEl.innerHTML = `${hasCompare ? `<s>${formatMoney(comparePrice)}</s> ` : ''}${formatMoney(price)}`;
    }
    if (unitPriceEl) {
      const unitPrice = selectedOption.dataset.unitPrice ? parseInt(selectedOption.dataset.unitPrice, 10) : 0;
      if (unitPrice) {
        const refValue = selectedOption.dataset.unitRefValue === '1' ? '' : selectedOption.dataset.unitRefValue;
        const refUnit = selectedOption.dataset.unitRefUnit;
        unitPriceEl.innerHTML = `(${formatMoney(unitPrice)}/${refValue}${refUnit})`;
        unitPriceEl.style.display = '';
      } else {
        unitPriceEl.style.display = 'none';
      }
    }
  }

  function handleAddBtnClick(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading') || btn.disabled) return;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(resp => {
        if (!resp.ok) throw new Error('Add to cart failed');
        return resp.json();
      })
      .then(() => {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.querySelector('span').textContent = 'Hinzugefügt ✓';

        fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
          .then(r => r.json())
          .then(cart => {
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: cart });
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          });

        setTimeout(() => {
          btn.classList.remove('is-added');
          btn.querySelector('span').textContent = 'In den Warenkorb';
        }, 2000);
      })
      .catch(() => {
        btn.classList.remove('is-loading');
      });
  }

  function handleQtyBtnClick(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.variantId;
    const quantity = parseInt(btn.dataset.quantity, 10) || 1;
    if (!variantId || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] }),
    })
      .then(resp => {
        if (!resp.ok) throw new Error('Add to cart failed');
        return resp.json();
      })
      .then(() => {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');

        // Refresh cart drawer via section rendering
        fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
          .then(r => r.json())
          .then(cart => {
            // Publish cart update event (same as PDP upsell)
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: cart });
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          });

        // Reset added state after 2s
        setTimeout(() => { btn.classList.remove('is-added'); }, 2000);
      })
      .catch(() => {
        btn.classList.remove('is-loading');
      });
  }

  function initScrollNav(container) {
    const list = container.querySelector('.cart-drawer-upsell-list');
    const prevBtn = container.querySelector('.cart-drawer-upsell-prev');
    const nextBtn = container.querySelector('.cart-drawer-upsell-next');
    const items = list.querySelectorAll('.cart-drawer-upsell-list-item');

    if (!prevBtn || !nextBtn || items.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    function getCurrentIndex() {
      const containerLeft = list.getBoundingClientRect().left;
      let closest = 0;
      let minDist = Infinity;
      items.forEach((item, i) => {
        const dist = Math.abs(item.getBoundingClientRect().left - containerLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function scrollTo(index) {
      if (index < 0 || index >= items.length) return;
      items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      setTimeout(updateBtns, 350);
    }

    function updateBtns() {
      const idx = getCurrentIndex();
      prevBtn.disabled = idx === 0;
      nextBtn.disabled = idx >= items.length - 1;
    }

    prevBtn.onclick = () => scrollTo(getCurrentIndex() - 1);
    nextBtn.onclick = () => scrollTo(getCurrentIndex() + 1);
    list.addEventListener('scroll', () => requestAnimationFrame(updateBtns), { passive: true });
    updateBtns();
  }

  // === Initialization ===

  async function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    const cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;
    if (cartDrawerItems.classList.contains('is-empty')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (upsells) {
      const clone = document.createElement('div');
      clone.id = 'cart-drawer-upsell-inserted';
      clone.innerHTML = upsells.innerHTML;
      wrapper.appendChild(clone);
    }

    // Load recommendations into the inserted upsell container
    const insertedUpsell = wrapper.querySelector('#cart-drawer-upsell');
    if (insertedUpsell) {
      await loadRecommendations(insertedUpsell);
    }
  }

  insertSectionCartDrawer();

  // Re-load recommendations when cart contents change
  // IMPORTANT: Only observe cart-drawer-items, NOT the upsell section,
  // otherwise interactions like opening a <select> dropdown trigger a
  // MutationObserver cycle that re-renders and kills the dropdown.
  function listenCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let timer;
    let isUpdating = false;

    function isUpsellMutation(mutation) {
      const upsell = document.querySelector('#cart-drawer-upsell');
      if (!upsell) return false;
      return upsell.contains(mutation.target);
    }

    const observer = new MutationObserver((mutations) => {
      // Skip mutations originating from our own upsell section
      if (mutations.every(isUpsellMutation)) return;
      // Skip if we're in the middle of our own update
      if (isUpdating) return;

      if (timer) clearTimeout(timer);
      timer = setTimeout(async () => {
        isUpdating = true;
        try {
          if (!document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) {
            await insertSectionCartDrawer();
          } else {
            const container = document.querySelector('#CartDrawer #cart-drawer-upsell') ||
                              document.querySelector('.cart-drawer-items-wrapper #cart-drawer-upsell');
            if (container) {
              await loadRecommendations(container);
            }
          }
        } finally {
          // Small delay before allowing observer to fire again
          setTimeout(() => { isUpdating = false; }, 500);
        }
      }, 400);
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
    });
  }
  listenCartDrawer();

  // Cart page support
  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items');
    if (!element) return;

    let timer;
    const observer = new MutationObserver(() => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(async () => {
        const container = document.querySelector('cart-items #cart-drawer-upsell');
        if (container) {
          await loadRecommendations(container);
        }
      }, 300);
    });

    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }
  listenCartPage();
})();
